function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import upperCase from 'lodash/upperCase';
import { CLICKSTREAM_EVENT_TYPE, CLICKSTREAM_SCHEMA_DATA } from './clickStreamEventSchema';
export var NO_AD_PLACEMENTS = new Set(['NFSHDPTopSlot', 'NFSHDPBottomSlot', 'ODASHTopSlot', 'HMIMHWTopSlot', 'HomePageHeroImage', 'HomePageRTBCard1', 'HomePageRTBCard2', 'HomePageRTBCard3', 'HomePageIlluminate', 'HomePageBanner', 'HDPOverTheTopSlot', 'ODASHBottomSlot']);
export function formExposureEventPayload(newLaneEventData) {
  var _newLaneEventData$exp, _newLaneEventData$exp2;

  var _CLICKSTREAM_SCHEMA_D = CLICKSTREAM_SCHEMA_DATA()[CLICKSTREAM_EVENT_TYPE.EXPOSURE],
      envelopeBlock = _CLICKSTREAM_SCHEMA_D.envelopeBlock,
      semanticBlock = _CLICKSTREAM_SCHEMA_D.semanticBlock;
  var snakeCasePlacementName = upperCase(newLaneEventData.placement_nm).split(' ').join('_');
  var experimentABTest = ["MTT_" + snakeCasePlacementName + "_ONSITE_MESSAGING", newLaneEventData.bucket_nm, newLaneEventData.selected_treatment_nm].filter(Boolean).join('.');
  var placementHoldoutABTest = "MTT_" + snakeCasePlacementName + "_HOLDOUT." + (newLaneEventData.placement_holdout_ind ? 'CONTROL' : 'ON');
  var globalHoldoutABTest = "ONSITE_MESSAGE_VALVE." + (newLaneEventData.global_holdout_ind ? 'CONTROL' : 'OMP_ON');
  var exposureBlock = {
    randomization_key: newLaneEventData.decision_context_guid,
    key_type_cd: 'guid',
    treatment_nm: [experimentABTest, placementHoldoutABTest, globalHoldoutABTest].concat(_toConsumableArray((newLaneEventData === null || newLaneEventData === void 0 ? void 0 : (_newLaneEventData$exp = newLaneEventData.exposureData) === null || _newLaneEventData$exp === void 0 ? void 0 : _newLaneEventData$exp.exposureAssignments) || [])),
    assignment_service_cd: 'abs',
    extended_info_txt: Object.assign({
      selected_treatment: !!newLaneEventData.selected_treatment_nm,
      ad_placement: !NO_AD_PLACEMENTS.has(newLaneEventData.placement_nm),
      displayed: newLaneEventData.should_display_ind && !!newLaneEventData.selected_treatment_nm,
      global_holdout: newLaneEventData.global_holdout_ind,
      placement_holdout: newLaneEventData.placement_holdout_ind
    }, newLaneEventData === null || newLaneEventData === void 0 ? void 0 : (_newLaneEventData$exp2 = newLaneEventData.exposureData) === null || _newLaneEventData$exp2 === void 0 ? void 0 : _newLaneEventData$exp2.exposureFlags)
  };
  var properties = {
    envelope: Object.assign({
      event_client_start_dtm: new Date().toISOString()
    }, envelopeBlock),
    semantic: Object.assign({}, semanticBlock),
    exposure: Object.assign({}, exposureBlock)
  };
  return properties;
}